/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sreality_Software_Key_HintInputs */

const cs_sreality_software_key_hint = /** @type {(inputs: Sreality_Software_Key_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Z dokumentace RK importu. Firemní tajemství — ne Seznam heslo makléře.`)
};

const en_sreality_software_key_hint = /** @type {(inputs: Sreality_Software_Key_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`From the RK import documentation. Office secret — not a broker’s Seznam password.`)
};

/**
* | output |
* | --- |
* | "From the RK import documentation. Office secret — not a broker’s Seznam password." |
*
* @param {Sreality_Software_Key_HintInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const sreality_software_key_hint = /** @type {((inputs?: Sreality_Software_Key_HintInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sreality_Software_Key_HintInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_sreality_software_key_hint(inputs)
	return cs_sreality_software_key_hint(inputs)
});